import {DASHBOARD_TOTAL_SESSIONS} from 'DashboardSessionAction';

export var DashboardTotalSessions = (state = {}, action) => {
  if (action.type === DASHBOARD_TOTAL_SESSIONS) {
    return action.payload;
  }
  return state;
}
